import { render } from "./ActualiteDetails.vue?vue&type=template&id=1c2b845e&scoped=true"
import script from "./ActualiteDetails.vue?vue&type=script&lang=js"
export * from "./ActualiteDetails.vue?vue&type=script&lang=js"

import "./ActualiteDetails.vue?vue&type=style&index=0&id=1c2b845e&scoped=true&lang=css"
import "./ActualiteDetails.vue?vue&type=style&index=1&id=1c2b845e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2b845e"]])

export default __exports__